import { BDCDashboardModule } from './bdc-dashboard/bdc-dashboard.module';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { TestdriveModule } from './testdrive/testdrive.module';
import { ServiceAppointmentModule } from './service-appointment/service-appointment.module';
import { SearchCustomerModule } from './search-customer/search-customer.module';
import { ServiceScheduleDashboardModule } from '../service/service-schedule-dashboard/service-schedule-dashboard.module';
import { SalesScheduleDashboardModule } from '../sales/sales-schedule-dashboard/sales-schedule-dashboard.module';
import { DeliveryModule } from './delivery/delivery.module';
import { TechAppointmentModule } from './tech-appointment/tech-appointment.module';
import { PendingAppointmentModule } from './pending-appointment/pending-appointment.module';
import { VehicleManagementModule } from '../sales/vehicle-management/vehicle-management.module';
import { InquiryAppointmentModule } from './inquiry-appointment/inquiry-appointment.module';
import { PartsAppointmentModule } from './parts-appointment/parts-appointment.module';
import { ProtectRoute } from '../shared/guards/protect-route.guard';
import { PartsScheduleModule } from '../parts/parts-schedule/parts-schedule.module';

const routes: Routes = [
    {
        path: '',
        canActivateChild: [ProtectRoute],
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                loadChildren: () => BDCDashboardModule
            },
            {
                path: 'testdrive',
                loadChildren: () => TestdriveModule
            },
            {
                path: 'service',
                loadChildren: () => ServiceAppointmentModule
            },
            {
                path: 'parts',
                loadChildren: () => PartsAppointmentModule
            },
            {
                path: 'pending',
                loadChildren: () => PendingAppointmentModule
            },
            {
                path: 'customer',
                loadChildren: () => SearchCustomerModule
            },
            {
                path: 'scheduledashboard',
                loadChildren: () => ServiceScheduleDashboardModule
            },
            {
                path: 'salesscheduledashboard',
                loadChildren: () => SalesScheduleDashboardModule
            },
            {
                path: 'partsscheduledashboard',
                loadChildren: () => PartsScheduleModule
            },
            {
                path: 'delivery',
                loadChildren: () => DeliveryModule
            },
            {
                path: 'tech-appointment',
                loadChildren: () => TechAppointmentModule
            },
            {
                path: 'appointment-conflicts',
                loadChildren: () => VehicleManagementModule
            },
            {
                path: 'vehicleinquiry',
                loadChildren: () => InquiryAppointmentModule
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BDCRoutingModule { }
